import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, ArrowRight } from 'lucide-react';
import './Blog.css';
import { blogPosts } from '../mock';
import { useSEO } from '../hooks/useSEO';

const Blog = () => {
  useSEO('/blog');
  return (
    <div className="blog">
      {/* Hero Section */}
      <section className="blog-hero">
        <div className="container">
          <h1 className="hero-medium">Blog & Resources</h1>
          <p className="body-large blog-subtitle">
            Tips, inspiration, and insights for planning your perfect beach celebration
          </p>
        </div>
      </section>

      {/* Featured Post */}
      <section className="featured-post section-padding-small">
        <div className="container">
          <div className="featured-content">
            <div className="featured-image-wrapper">
              <img
                src={blogPosts[0].image}
                alt={blogPosts[0].title}
                className="featured-image"
              />
            </div>
            <div className="featured-details">
              <span className="post-category">{blogPosts[0].category}</span>
              <h2 className="heading-1">{blogPosts[0].title}</h2>
              <p className="body-large featured-excerpt">{blogPosts[0].excerpt}</p>
              <div className="post-meta">
                <span className="body-small">
                  <Calendar size={14} /> {blogPosts[0].date}
                </span>
                <span className="body-small">
                  <User size={14} /> {blogPosts[0].author}
                </span>
              </div>
              <button className="btn-secondary">
                Read More <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="blog-posts section-padding-small">
        <div className="container">
          <h2 className="heading-1 section-title">Recent Articles</h2>
          <div className="posts-grid">
            {blogPosts.slice(1).map((post) => (
              <article key={post.id} className="post-card hover-lift">
                <div className="post-image-wrapper">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="post-image"
                  />
                  <span className="post-category-badge">{post.category}</span>
                </div>
                <div className="post-content">
                  <h3 className="heading-3">{post.title}</h3>
                  <p className="body-regular post-excerpt">{post.excerpt}</p>
                  <div className="post-meta">
                    <span className="body-small">
                      <Calendar size={14} /> {post.date}
                    </span>
                    <span className="body-small">
                      <User size={14} /> {post.author}
                    </span>
                  </div>
                  <button className="post-link">
                    Read More <ArrowRight size={14} />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter CTA */}
      <section className="newsletter-cta section-padding-small">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-1">Stay Inspired</h2>
            <p className="body-large">
              Subscribe to our newsletter for beach dining tips, seasonal menus, 
              and exclusive offers.
            </p>
            <div className="newsletter-form-large">
              <input
                type="email"
                placeholder="Enter your email address"
                className="newsletter-input-large"
              />
              <button className="btn-primary">Subscribe</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;